import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import './AdSetNotification.css';

const tabs = [
  { key: 'pending',   label: '🕐 Pending' },
  { key: 'approved',  label: '✅ Approved' },
  { key: 'published', label: '🚀 Published' },
  { key: 'expired',   label: '⏳ Expired' },
];

export default function AdSetNotification() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('pending');
  const [adsets, setAdsets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/adsets/my').then(res => setAdsets(res.data.data || [])).catch(() => setAdsets([])).finally(() => setLoading(false));
  }, []);

  const filtered = adsets.filter(a => {
    if (activeTab === 'pending') return a.status === 'pending';
    if (activeTab === 'approved') return a.status === 'approved';
    if (activeTab === 'published') return a.status === 'active' || a.status === 'published';
    if (activeTab === 'expired') return a.status === 'expired';
    return true;
  });

  return (
    <div className="asn-page">
      <div className="asn-header">
        <button className="asn-back" onClick={() => navigate(-1)}>←</button>
        <span>📣 Ad Set Notification</span>
      </div>

      <div className="asn-body container">
        <div className="asn-sidebar">
          {tabs.map(tab => (
            <div key={tab.key} className={`asn-tab ${activeTab === tab.key ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.key)}>
              {tab.label}
            </div>
          ))}
        </div>

        <div className="asn-content">
          {loading ? (
            <div className="asn-empty">Loading...</div>
          ) : filtered.length === 0 ? (
            <div className="asn-empty">No Data Found</div>
          ) : (
            filtered.map((ad, i) => (
              <div key={i} className="asn-card">
                {ad.image && <img src={`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/${ad.image}`} alt={ad.adTitle} className="asn-card-img" />}
                <div className="asn-card-info">
                  <h4>{ad.adTitle || ad.businessName}</h4>
                  <p>{ad.plan} Plan · {ad.adType}</p>
                  <p className="asn-card-date">📅 {new Date(ad.createdAt).toLocaleDateString('en-IN')}</p>
                </div>
                <span className={`asn-status ${ad.status}`}>{ad.status}</span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
